import { DataDisplayEvent, DataSourceExecutionEvent, Label, Layout, Textbox } from "@mcleod/components";
import { Alignment, ModelRow } from "@mcleod/core";
import { TransmissionStatusQuickInfo } from "./TransmissionStatusQuickInfo";
import { AutogenLayoutEdiFuncAck } from "./autogen/AutogenLayoutEdiFuncAck";

export class EdiFuncAck extends AutogenLayoutEdiFuncAck {
    override onLoad(): void {
        this.textboxBatchId.printableDuringAdd = true;
        this.textboxBatchId.printableDuringUpdate = true;
        this.setupTextboxBatchIdTooltipContent();
    }

    sourceViewEdiOrderAfterModeChange(){
             // will be used in the future

        // if (this.mainDataSource.mode == DataSourceMode.SEARCH) {
        //     this.textboxBatchId.printable = false;
        //     this.textboxBatchId.enabled = true;
        //     this.textboxAk501TrxAckCd.printable = false;
        //     this.textboxAk501TrxAckCd.enabled = true;
        //     this.textboxGSStatusCode.printable = false;
        //     this.textboxGSStatusCode.enabled = true;
        //     this.textboxCreateDate.printable = false;
        //     this.textboxCreateDate.enabled = true;
        //     this.textboxAk902Sets.printable = false;
        //     this.textboxAk902Sets.enabled = true;
        //     this.textboxEdiError.printable = false;
        //     this.textboxEdiError.enabled = true;
        //     this.checkboxTransmitted.enabled = true;
        // }
    }

    textboxAk501TrxAckCdOnDisplay(event) {
        if (this.sourceEdiFunctionalAck.activeRow != null) {
            const faStatus = this.sourceEdiFunctionalAck.activeRow.get("ak501_trx_ack_cd");
            if (faStatus == "A") {
                this.textboxAk501TrxAckCd.text = "Accepted";
            } else if (faStatus == "R") {
                this.textboxAk501TrxAckCd.text = "Rejected";
            } else {
                this.textboxAk501TrxAckCd.text = "Unknown";
            }
        }
    }

    textboxGSStatusCodeOnDisplay(event) {
        if (this.sourceEdiFunctionalAck.activeRow != null) {
            const gsStatus = this.sourceEdiFunctionalAck.activeRow.get("ak901_func_ack_cd");
            if (gsStatus == "A") {
                this.textboxGSStatusCode.text = "Accepted";
            } else if (gsStatus == "R") {
                this.textboxGSStatusCode.text = "Rejected";
            } else {
                this.textboxGSStatusCode.text = "Unknown";
            }
        }
    }

    panelFAOnDataDisplay(event) {
        if (this.mainDataSource.activeRow != null) {
            this.layoutFASeg.faId = this.mainDataSource.activeRow?.get("id");
        }
    }

    sourceEdiFunctionalAckBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.id = this.mainDataSource?.activeRow?.get("id");
    }


    private _showFieldsByDirection(row: ModelRow<any>) {
        const tenderDirection = row?.get("direction");
        if ("I" == tenderDirection) {//outbound FA
            this.textboxCreateDate.caption = "Sent Date";
            this.textboxCreateDate.tooltip = "Date the Functional Acknowledgement was sent to the trading partner.";
            this.checkboxTransmitted.visible = true;
            this.checkboxTransmitted.caption = "Transmitted?";
            this.labelStatus.visible = true;
        } else { //inbound FA
            this.textboxCreateDate.caption = "Received Date";
            this.textboxCreateDate.tooltip = "Date the Functional Acknowledgement was received from the trading partner.";
            this.checkboxTransmitted.visible = false;
            this.labelStatus.visible = false;
        }
    }


    /** This is an event handler for the onDataDisplay event of labelStatus.  */
    labelStatusOnDataDisplay(event: DataDisplayEvent) {
        if (this.sourceEdiLog.activeRow != null) {
            const statusLabel = event.target as Label;
            statusLabel.tooltipDynamicContent = async () => {
                if (statusLabel.text !== "Not Sent") {
                    const layout = await Layout.getLoadedLayout("lme/datafusion/TransmissionStatusQuickInfo") as TransmissionStatusQuickInfo;
                    await layout.sourceEdiLog?.search({ id: this.sourceEdiLog.activeRow.get("id") });
                    return layout;
                }
            }
            const status = this.sourceEdiLog.activeRow.get("status");
            if ("4" == status) {
                const successful = this.sourceEdiLog.activeRow.get("was_successful");
                this.labelStatus.text = ("Y" == successful) ? "(Successful)" : "(Failed)";
                this.checkboxTransmitted.checked = "Y" == successful;
            }

        }
    }

    private setupTextboxBatchIdTooltipContent() {
        this.textboxBatchId.tooltipDynamicContent = async () => {
            if (this.sourceEdiFunctionalAck?.activeRow?.get("batch_id") > "0") {
                const layout = await Layout.getLoadedLayout("lme/datafusion/TransmissionStatusQuickInfo") as TransmissionStatusQuickInfo;
                if (layout.sourceEdiLog !== null) {
                    const direction = this.mainDataSource.activeRow.get("direction") === "I" ? "O" : "I";
                    await layout.sourceEdiLog.search({
                        direction: direction,
                        func_batch: this.sourceEdiFunctionalAck.activeRow.get("batch_id"),
                        batch: this.sourceEdiFunctionalAck.activeRow.get("batch_id"),
                        func_receiver_id: direction === "I" ?
                            this.sourceEdiFunctionalAck.activeRow.get("receiver_id") :
                            this.sourceEdiFunctionalAck.activeRow.get("partner_id"),
                        receiver_id: direction === "I" ?
                            this.sourceEdiFunctionalAck.activeRow.get("receiver_id") :
                            this.sourceEdiFunctionalAck.activeRow.get("alt_partner_id"),
                        func_version: this.sourceEdiFunctionalAck.activeRow.get("version"),
                        transaction_type: 'F',
                        search_receiver_id: this.sourceEdiFunctionalAck.activeRow.get("partner_id")
                    });
                }
                return layout;
            }
            return null;
        };
    }

    /** This is an event handler for the afterExecution event of sourceEdistatus. */
    mainDataSourceAfterExecution(event: DataSourceExecutionEvent) {
        const FAId = this.mainDataSource.activeRow.get("func_ack_id");
        if (FAId != null) {
            this.sourceEdiFunctionalAck.search({ "id": this.mainDataSource.activeRow.get("func_ack_id") }).then(result => {
                if (result.modelRows.length > 0) {
                    this.layoutFASeg.sourceEdiFunctionalSeg.search({ func_ack_id: this.sourceEdiFunctionalAck.activeRow.get("id") });
                    this.sourceEdiLog.search({
                        "func_receiver_id": this.sourceEdiFunctionalAck.activeRow.get("partner_id"),
                        "receiver_id": this.sourceEdiFunctionalAck.activeRow.get("alt_partner_id"),
                        "func_version": this.sourceEdiFunctionalAck.activeRow.get("version"),
                        "transaction_type": "F",
                        "batch": this.sourceEdiFunctionalAck.activeRow.get("batch_id"),
                        "direction": this.sourceEdiFunctionalAck.activeRow.get("direction")
                    });
                }
            });
        } else {
            const direction = this.mainDataSource.activeRow.get("direction") === "I" ? "O" : "I";
            this.sourceEdiFunctionalAck.search({
                "partner_id": this.mainDataSource.activeRow.get("partner_id"),
                "ak102_group_ctl_no": this.mainDataSource.activeRow.get("batch"),
                "rec_trans_set_code": "S",
                "direction": direction,
                "ak202_trx_ctl_no": this.mainDataSource.activeRow.get("st02_trxset_cntlno")
            }).then(result => {
                if (result.modelRows.length > 0) {
                    this.layoutFASeg.sourceEdiFunctionalSeg.search({ func_ack_id: this.sourceEdiFunctionalAck.activeRow.get("id") });
                    this.sourceEdiLog.search({
                        "func_receiver_id": this.sourceEdiFunctionalAck.activeRow.get("partner_id"),
                        "receiver_id": this.sourceEdiFunctionalAck.activeRow.get("alt_partner_id"),
                        "func_version": this.sourceEdiFunctionalAck.activeRow.get("version"),
                        "transaction_type": "F",
                        "batch": this.sourceEdiFunctionalAck.activeRow.get("batch_id"),
                        "direction": this.sourceEdiFunctionalAck.activeRow.get("direction")
                    });
                }
            });
        }

        this._showFieldsByDirection(this.mainDataSource.activeRow);
    }
}
